import { isNull, isUndefined } from 'lodash';

/* eslint-disable no-restricted-properties */
const getPartnerLogo = (): string => {
  let logo = process.env.REACT_APP_PLATFORM_DEFAULT_LOGO || 'https://assets.it22.nl/fortes-energy/admin/fortes-energy-logo.png';

  const partnerGlobalConfigLocal: any = JSON.parse(window.localStorage.getItem('partner_settings'));

  if (!isNull(partnerGlobalConfigLocal) && !isUndefined(partnerGlobalConfigLocal)) {
    logo = `${process.env.REACT_APP_IMAGE_UPLOAD_URL}/images/user/${partnerGlobalConfigLocal?.logo}`;
  }
  return logo;
};

export default getPartnerLogo;
